import React from 'react';
import { Link } from 'react-router-dom';
import { icons } from '../common/icons.js';

const Footer = () => (
  <footer className="bg-surface border-t border-subtle">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 text-center">
        <div className="flex flex-col items-center gap-3">
          <a href="https://hekaos.com" aria-label="Hekaos Website" className="text-amber-500 hover:text-white transition">
            {icons.hekaosLarge}
          </a>
          <p className="max-w-xl text-sm text-secondary leading-relaxed">
            <span className="block">
              <span className="text-amber-400 font-medium">HEKAOS</span> is where{' '}
              <span className="text-violet-400">cutting-edge technology</span> awakens{' '}
              <span className="text-amber-400">Ancient Lore</span>.
            </span>
            <span className="block mt-1">
              We engineer <span className="text-amber-400">order, intelligence & value</span> from{' '}
              <span className="text-violet-400">complex systems</span>—turning raw potential into{' '}
              <span className="text-violet-400">engineered intelligence</span>.
            </span>
            <span className="block mt-1">
              Fusing <span className="text-violet-400">Advanced AI & Data Science</span> with{' '}
              <span className="text-amber-400">visionary thinking</span>, we{' '}
              <span className="text-violet-400">build the future</span> from{' '}
              <span className="text-amber-400">chaos</span>.
            </span>
          </p>
        </div>

        <div className="flex flex-col items-center gap-4">
          <h4 className="text-sm font-semibold tracking-wide uppercase">
            <span className="text-amber-400">HEKA</span>
            <span className="text-violet-400">OS</span>
          </h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                to="/"
                className="accent-amber hover:text-primary transition-colors"
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/vision"
                className="accent-amber hover:text-primary transition-colors"
              >
                Vision &amp; Philosophy
              </Link>
            </li>
            <li>
              <Link
                to="/platforms"
                className="text-violet-400 hover:text-white transition"
              >
                Platforms &amp; Products
              </Link>
            </li>
            <li>
              <Link
                to="/intelligence"
                className="text-violet-400 hover:text-white transition"
              >
                Intelligence Corner
              </Link>
            </li>
            <li>
              <Link
                to="/connect"
                className="accent-amber hover:text-primary transition-colors"
              >
                Connect
              </Link>
            </li>
          </ul>
        </div>

        <div className="flex flex-col items-center gap-4">
          <h4 className="text-sm font-semibold tracking-wide uppercase text-amber-400">Connect</h4>

          <div className="flex items-center gap-4">
            <a href="tel:+919235327048"  target="_blank" rel="noopener noreferrer" aria-label="Phone" className="text-amber-400 hover:text-white transition">
              {icons.phone}
            </a>
            <a href="mailto:hekaosIT@gmail.com"  target="_blank" rel="noopener noreferrer" aria-label="Email" className="text-violet-400 hover:text-white transition">
              {icons.email}
            </a>
            <a href="https://maps.app.goo.gl/CK6BygVuDRkMvG6U7"  target="_blank" rel="noopener noreferrer" aria-label="Location" className="text-amber-400 hover:text-white transition">
              {icons.location}
            </a>
          </div>

          <div className="flex items-center gap-4">
            <a href="https://www.linkedin.com/company/hekaos/"  target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-violet-400 hover:text-white transition">
              {icons.linkedin}
            </a>
            <a href="https://x.com/HekaosInc"  target="_blank" rel="noopener noreferrer" aria-label="X" className="text-amber-400 hover:text-white transition">
              {icons.X}
            </a>
            <a href="https://github.com/hekaos"  target="_blank" rel="noopener noreferrer" aria-label="GitHub" className="text-violet-400 hover:text-white transition">
              {icons.github}
            </a>
            <a href="https://www.youtube.com/@Hekaos"  target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="text-amber-400 hover:text-white transition">
              {icons.youtube}
            </a>
          </div>
        </div>
      </div>

      <div className="mt-10 pt-6 border-t border-slate-800">
        <p className="text-xs text-muted flex items-center justify-center gap-2 whitespace-nowrap">
          © {new Date().getFullYear()}
          <a href="https://hekaos.com" className="inline-flex items-center gap-1">
            <span className="text-amber-400">HEKA</span>
            <span className="text-violet-400">OS</span>
          </a>
          <span>All rights reserved.</span>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;

